import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Y si estoy exagerando?',
  answer: 'Entonces esto te devuelve calma y orden. Y eso ya vale. No hay pérdida en observar con estructura.'
}, {
  question: '¿Y si el pediatra me dice que espere?',
  answer: 'Aquí tienes el guión exacto para responder y los pasos alternos (Early Intervention / Child Find) para que no dependas de una sola opinión.'
}, {
  question: '¿Y si me da miedo verlo por escrito?',
  answer: 'Más miedo da quedarse congelado/a. Esto no etiqueta a tu hijo. Esto te mueve a ti hacia la acción constructiva.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#FDF8F3] py-20 px-6" data-id="element-53">
      <div className="max-w-2xl mx-auto" data-id="element-54">
        <FadeIn data-id="element-55">
          <h2 className="font-serif text-3xl text-[#1B2A4A] mb-12 text-center" data-id="element-56">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-57">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-[#1B2A4A]/5 overflow-hidden transition-all duration-300" data-id="element-58">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-59">
                  <span className="font-serif text-lg text-[#1B2A4A] font-medium" data-id="element-60">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#3BBFAD] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-61" />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-62">
                  <div className="p-6 pt-0 text-[#1B2A4A]/70 leading-relaxed" data-id="element-63">
                    {faq.answer}
                  </div>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}